import React from "react";
import { Col, Table, Container } from "react-bootstrap";
import classes from "../../WebsiteManagement/websiteManagement.module.css";

const dash = (value) => (value != null && value !== "" ? value : "—");

const HolidayCustomerDetails = ({ booking }) => (
  <Container fluid style={{ marginTop: "5vh" }}>
    <Col lg={12} md={12} className={classes.Response2}>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Customer Name</th>
            <th>Email</th>
            <th>Phone Number</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{dash(booking?.name)}</td>
            <td>{dash(booking?.email)}</td>
            <td>{dash(booking?.phone)}</td>
          </tr>
        </tbody>
      </Table>
    </Col>
  </Container>
);

export default HolidayCustomerDetails;
